import { treaty } from "@elysiajs/eden";
import type { app } from "@api";

const isServer = typeof window === "undefined";
const getLanguage = () => {
  if (typeof localStorage === "undefined") return "pt";

  try {
    return JSON.parse(localStorage.getItem("language") ?? "null")?.value ?? "pt";
  } catch {
    return "pt";
  }
};

const config = {
  API_URL: isServer ? null : import.meta.env.VITE_APP_API_HOST,
  FRONTEND_URL: isServer ? null : import.meta.env.VITE_APP_FRONTEND_URL,
};

export const api = treaty<typeof app>(
  config.API_URL || "http://localhost:3000",
  {
    headers: () => ({
      origin: config.FRONTEND_URL,
      "Accept-Language": getLanguage(),
      'ngrok-skip-browser-warning':true
    }),
    fetch: {
      credentials: "include",
    },
  },
);
